"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
var minAge_1 = __importDefault(require("../minAge"));
function isOfLegalAge() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!value) return new classes_1.ValidationResult(true);
  var isValid = minAge_1.default.run(value, {
    minAge: 18
  }).isValid;
  var message = isValid ? '' : '';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isOfLegalAge);